export default __webpack_public_path__ + "static/media/Polymer_Logistics_6425.d225eb2f.jpg";